/**********************************
 * Year End Popup - Final Version
 **********************************/
const GUEST_CLICK_TIME_KEY = "__YEAR_END_GUEST_CLICK_TIME__";
const GUEST_EXPIRE_DAYS = 30;
// annual-feedback.js 顶部 or YearEnd 相关逻辑最前面
const FLOATING_SESSION_CLOSE_KEY = "__YEAR_END_FLOATING_SESSION_CLOSED__";
let __YEAR_END_FLOAT_CHECK_PROMISE__ = null;
let __YEAR_END_FLOAT_CAN_SHOW__ = null;

// const newPageName = window.utils.getRouteName();
// console.log("获取页面", newPageName);
function getAnnualFeedbackRouteName() {
  if (window.utils && typeof window.utils.getRouteName === "function") {
    return window.utils.getRouteName();
  }
  return "otherPage";
}
const PageOverlay = document.querySelector(".PageOverlay");
let yearEndConfigReadyResolve;
const yearEndConfigReady = new Promise((resolve) => {
  yearEndConfigReadyResolve = resolve;
});

/** ===============================
 * 常量 & 工具函数
 =============================== */
const STORAGE = {
  RECEIVED: "__YEAR_END_RECEIVED__",
  CLOSED_DATE: "__YEAR_END_CLOSED_DATE__",
};

/** 安全解析接口响应，避免 HTML/空串触发 Safari SyntaxError（观测云噪声） */
function parseResponseJson(res) {
  if (!res.ok) {
    return Promise.reject(new Error("[YearEnd] HTTP " + res.status));
  }
  return res.text().then(function (text) {
    var trimmed = (text || "").trim();
    if (!trimmed) {
      return Promise.reject(new Error("[YearEnd] empty response"));
    }
    try {
      return JSON.parse(trimmed);
    } catch (e) {
      return Promise.reject(new Error("[YearEnd] invalid JSON"));
    }
  });
}

function getFloatingDiscountText() {
  console.log("进入侧边文案获取", window.__YEAR_END_POPUP_CONFIG__);
  const config = window.__YEAR_END_POPUP_CONFIG__;
  const pack = config?.content?.packges?.[0];
  if (!pack?.title) return "";

  const match = pack.title.match(/(\d+%)/);
  return match ? match[1] : "";
}
function updateFloatingButtonText() {
  console.log("侧边文案更新");
  const floatingLeft = document.querySelector(".year-end-floating-left");
  if (!floatingLeft) return;

  if (!window.__YEAR_END_POPUP_CONFIG__) {
    console.warn("YEAR_END config 未就绪，跳过文案更新");
    return;
  }

  const text = getFloatingDiscountText();
  if (!text) return;

  floatingLeft.textContent = text;
}
async function shouldShowFloatingButton() {
  console.log("进来弹窗函数");

  /** =========================
   * ⭐ 路由黑名单（通用）
   ========================= */
  const denyList = window.__YEAR_END_FLOAT_NO_POPUP__ || [];
  if (denyList.some((p) => location.pathname.startsWith(p))) {
    return false;
  }

  const customerId = window.getAuthorization?.();

  /** =========================
   * 🟡 未登录用户：纯本地逻辑
   ========================= */
  if (!customerId) {
    return isGuestClickValid();
  }

  /** =========================
   * ⭐ 已有结果，直接返回
   ========================= */
  if (__YEAR_END_FLOAT_CAN_SHOW__ !== null) {
    return __YEAR_END_FLOAT_CAN_SHOW__;
  }

  /** =========================
   * ⭐ 已在请求中，复用 Promise
   ========================= */
  if (__YEAR_END_FLOAT_CHECK_PROMISE__) {
    return __YEAR_END_FLOAT_CHECK_PROMISE__;
  }

  /** =========================
   * 🟢 登录用户：只请求一次接口
   ========================= */
  __YEAR_END_FLOAT_CHECK_PROMISE__ = fetch(
    `${window.API_BASE}/api/klaiyi/popup_manage/year_end/customer_orders_coupon?customer_id=${customerId}`,
    {
      method: "GET",
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
    }
  )
    .then(parseResponseJson)
    .then((data) => {
      const canShow = data?.data?.is_show !== 0;
      __YEAR_END_FLOAT_CAN_SHOW__ = canShow;
      return canShow;
    })
    .catch((err) => {
      console.warn("[YearEnd] floating check failed", err && err.message);
      __YEAR_END_FLOAT_CAN_SHOW__ = false;
      return false;
    });

  return __YEAR_END_FLOAT_CHECK_PROMISE__;
}
window.__YEAR_END_FLOATING_SHOWN__ = false;

/** 是否 Shopify 登录客户（以 customerData.loggedIn / id 为准） */
function isYearEndLoggedInCustomer() {
  if (window.customerData) {
    return (
      window.customerData.loggedIn === true && !!window.customerData.id
    );
  }
  return !!window.getAuthorization?.();
}

/** 是否已领过年终券（本地标记） */
function hasClaimedYearEndCoupon() {
  return (
    hasReceived() ||
    localStorage.getItem("__YEAR_END_HAS_INTERACTED__") === "1"
  );
}

/**
 * 彻底隐藏购物车年终横幅（未登录 / 不可展示时用）。
 * 直接收回高度，避免 is-slot-held 留下空白或黄条闪现。
 */
function hideCartDiscountBannerCompletely() {
  console.log('需要隐藏横幅');
  document.documentElement.classList.remove("cart-expect-discount-banner");
  var banner =
    document.getElementById("cart-discount-banner-slot") ||
    document.querySelector(".cart-discount-banner--slot");
  if (!banner) return;
  banner.classList.remove("is-expected", "is-slot-held", "is-ready");
  banner.setAttribute("aria-hidden", "true");
  banner.dataset.bound = "";
}

/**
 * 购物车年终横幅展示条件（PC/M 一致）：
 * 1) 已登录 2) 已领券 3) 配置有效 4) 接口允许（已领未用等）
 * 未登录、活动结束、没领过、配置空、接口不允许 → 不展示
 */
function tryShowCartDiscountBanner(discountTitle, discountCode) {
  if (
    !(
      location.pathname === "/cart" || location.pathname.startsWith("/cart/")
    )
  ) {
    return;
  }

  if (!isYearEndLoggedInCustomer()) {
    hideCartDiscountBannerCompletely();
    return;
  }

  if (!hasClaimedYearEndCoupon()) {
    hideCartDiscountBannerCompletely();
    return;
  }

  if (!discountTitle && !discountCode) {
    hideCartDiscountBannerCompletely();
    return;
  }

  shouldShowFloatingButton()
    .then(function (canShow) {
      if (!canShow || !isYearEndLoggedInCustomer()) {
        hideCartDiscountBannerCompletely();
        return;
      }
      fillCartDiscountBannerSlot(discountTitle, discountCode);
    })
    .catch(function () {
      hideCartDiscountBannerCompletely();
    });
}

/**
 * 填充购物车折扣横幅槽位（不 insert DOM，避免 CLS）。
 * 复制成功/失败提示与 GTM 埋点与原先逻辑一致。
 */
function fillCartDiscountBannerSlot(discountTitle, discountCode) {
  console.log('填充购物车折扣横幅槽位');
  // 硬门禁：未登录绝不展示横幅
  if (!isYearEndLoggedInCustomer()) {
    hideCartDiscountBannerCompletely();
    return;
  }
  if (!hasClaimedYearEndCoupon()) {
    hideCartDiscountBannerCompletely();
    return;
  }

  var banner =
    document.getElementById("cart-discount-banner-slot") ||
    document.querySelector(".cart-discount-banner--slot");

  // 购物车 main-cart 模板已 SSR 槽位；无槽位时不 insertBefore（避免推列表 CLS）
  if (!banner) {
    var onCart =
      location.pathname === "/cart" ||
      location.pathname.startsWith("/cart/");
    if (onCart || document.querySelector(".main_cart")) {
      return;
    }
    if (document.querySelector(".cart-discount-banner.is-ready")) return;
    banner = document.createElement("div");
    banner.className = "cart-discount-banner cart-discount-banner--slot";
    banner.id = "cart-discount-banner-slot";
    banner.innerHTML =
      '<div class="cart-discount-cen" style="display:flex;align-items:center">' +
      '<span class="cart-discount-banner__text" style="display:flex;align-items:center;gap:4px">' +
      '<span class="text-default">Save</span>' +
      '<span class="text-highlight cart-discount-banner__title"></span>' +
      '<span class="text-default">with</span>' +
      '<span class="text-highlight cart-discount-banner__code"></span>' +
      "</span>" +
      '<span class="cart-discount-banner__copy" role="button" tabindex="0" aria-label="Copy discount code"></span>' +
      "</div>" +
      '<div class="cart-discount-timer" style="display:flex;align-items:center;gap:4px;font-weight:500">' +
      '<span class="expires_in" style="margin-right:4px">Expires In</span>' +
      '<span class="end-time cart-discount-banner__h" style="display:inline-block">00</span><span>:</span>' +
      '<span class="end-time cart-discount-banner__m" style="display:inline-block">00</span><span>:</span>' +
      '<span class="end-time cart-discount-banner__s" style="display:inline-block">00</span>' +
      "</div>";
    var list = document.querySelector(".Cart__ItemList");
    if (list && list.parentNode) {
      list.parentNode.insertBefore(banner, list);
    } else {
      return;
    }
  }

  if (banner.classList.contains("is-ready") && banner.dataset.bound === "1") {
    var titleEl0 = banner.querySelector(".cart-discount-banner__title");
    var codeEl0 = banner.querySelector(".cart-discount-banner__code");
    if (titleEl0) titleEl0.textContent = discountTitle || "";
    if (codeEl0) codeEl0.textContent = discountCode || "";
    banner.dataset.code = discountCode || "";
    return;
  }

  var titleEl = banner.querySelector(".cart-discount-banner__title");
  var codeEl = banner.querySelector(".cart-discount-banner__code");
  var copyIcon = banner.querySelector(".cart-discount-banner__copy");
  var hSpan = banner.querySelector(".cart-discount-banner__h");
  var mSpan = banner.querySelector(".cart-discount-banner__m");
  var sSpan = banner.querySelector(".cart-discount-banner__s");

  if (titleEl) titleEl.textContent = discountTitle || "";
  if (codeEl) codeEl.textContent = discountCode || "";
  banner.dataset.code = discountCode || "";

  if (copyIcon && copyIcon.dataset.bindCopy !== "1") {
    copyIcon.dataset.bindCopy = "1";
    copyIcon.addEventListener("click", function () {
      var code = banner.dataset.code || "";
      if (!code) return;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(function () {
          window.utils.showCopyTip("Copied!", { type: "success" });
        });
      } else {
        var textarea = document.createElement("textarea");
        textarea.value = code;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand("copy");
          window.utils.showCopyTip("Copied!", { type: "success" });
        } catch (e) {
          window.utils.showCopyTip("Copy failed!", { type: "error" });
        }
        document.body.removeChild(textarea);
      }
      pushAnnualRewardViewEvent(
        "popUp_Click",
        "popUp::AnnualReward-Win::Copy"
      );
    });
  }

  if (hSpan && mSpan && sSpan && banner.dataset.timerBound !== "1") {
    banner.dataset.timerBound = "1";
    var countdownSeconds = 4 * 60 * 60;
    function updateTimer() {
      var h = Math.floor(countdownSeconds / 3600)
        .toString()
        .padStart(2, "0");
      var m = Math.floor((countdownSeconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
      var s = (countdownSeconds % 60).toString().padStart(2, "0");
      hSpan.textContent = h;
      mSpan.textContent = m;
      sSpan.textContent = s;
      countdownSeconds--;
      if (countdownSeconds < 0) countdownSeconds = 4 * 60 * 60;
    }
    updateTimer();
    setInterval(updateTimer, 1000);
  }
  console.log('需要横幅02');
  document.documentElement.classList.add("cart-expect-discount-banner");
  banner.classList.remove("is-slot-held");
  banner.classList.add("is-expected", "is-ready");
  banner.setAttribute("aria-hidden", "false");
  banner.dataset.bound = "1";
}

function showFloatingButton() {

  // ⭐ 防止重复调用
  if (window.__YEAR_END_FLOATING_SHOWN__) {
    return;
  }
  window.__YEAR_END_FLOATING_SHOWN__ = true;

  const floatingBtn = document.querySelector(".year-end-floating-button");
  if (!floatingBtn) return;
  console.log("获取是否已经点击按钮领取code");
  // if (!hasReceived()) return;
  /* =========================
   * 🚫 不显示悬浮按钮的页面拦截
   ========================= */
  var noPopupList = window.__YEAR_END_FLOAT_NO_POPUP__ || [];

  if (Array.isArray(noPopupList) && noPopupList.length > 0) {
     console.log("进禁止显示悬浮页面01");
    var currentPath = location.pathname.replace(/\/$/, "");

    var shouldBlock = noPopupList.some(function (path) {
      if (!path) return false;
      var rulePath = path.replace(/\/$/, "");
      return currentPath === rulePath || currentPath.startsWith(rulePath + "/");
    });

    if (shouldBlock) {
      console.log("进禁止显示悬浮页面02");
    }else{
      console.log("显示悬浮页面");
      // 1️⃣ 更新悬浮按钮文案
      updateFloatingButtonText();
      // 2️⃣ 显示悬浮按钮
      floatingBtn.classList.remove("opcity-hide");
    }
  }
  pushAnnualRewardFloatingEvent("view", "btn::AnnualReward");
  const config = window.__YEAR_END_POPUP_CONFIG__;
  if (!config) {
    clearCartDiscountBannerExpect();
    return;
  }

  const pack = config.content?.packges?.[0];
  if (!pack) {
    clearCartDiscountBannerExpect();
    return;
  }

  const discountTitle = pack.title || ""; // 接口返回的 title
  const discountCode = pack.code || ""; // 接口返回的 code
  const discountPrice = pack.sub_title || ""; // 接口返回的 sub_title
  // 3️⃣ 购物车横幅：仅登录 + 已领未用（接口允许）才展示；未登录绝不展示
  tryShowCartDiscountBanner(discountTitle, discountCode);

  // 个人中心优惠码
  if (location.pathname.replace(/\/$/, "") === "/pages/my-coupons") {
    insertCouponToMyCoupon({
      title: discountTitle,
      code: discountCode,
      price: discountPrice,
    });
  }
}

function hideFloatingButton() {
  const floatingBtn = document.querySelector(".year-end-floating-button");
  if (floatingBtn) {
    floatingBtn.classList.add("opcity-hide");
  }
  // 悬浮入口关闭时，购物车横幅一并按规则收起
  hideCartDiscountBannerCompletely();
}

/**
 * 收回未就绪的购物车横幅占位（不影响已 is-ready 的正式横幅）。
 * 不可展示时直接去掉 expect，不再 is-slot-held 留高度。
 */
function clearCartDiscountBannerExpect() {
  var banner =
    document.getElementById("cart-discount-banner-slot") ||
    document.querySelector(".cart-discount-banner--slot");
  if (banner && banner.classList.contains("is-ready")) return;

  document.documentElement.classList.remove("cart-expect-discount-banner");
  if (banner) {
    banner.classList.remove("is-expected", "is-slot-held");
    banner.setAttribute("aria-hidden", "true");
  }
}

function today() {
  return new Date().toISOString().slice(0, 10);
}

function hasReceived() {
  return localStorage.getItem(STORAGE.RECEIVED) === "1";
}

function markReceived() {
  localStorage.setItem(STORAGE.RECEIVED, "1");
}

function hasClosedToday() {
  return localStorage.getItem(STORAGE.CLOSED_DATE) === today();
}

function markClosedToday() {
  localStorage.setItem(STORAGE.CLOSED_DATE, today());
}

function isPC() {
  return window.matchMedia("(min-width: 769px)").matches;
}

function setSecondPicStyle(popup) {
  const popMainCen = popup.querySelector(".pop_main_cen");
  if (!popMainCen) return;

  /** ===== 样式逻辑（保持你原有的） ===== */
  if (isPC()) {
    popMainCen.style.height = "557px";
    popMainCen.style.backgroundImage =
      'url("https://cdn.shopify.com/s/files/1/1720/3725/files/Group_1321318725.png?v=1767497806")';
  } else {
    popMainCen.style.height = "428px";
    popMainCen.style.backgroundImage =
      'url("https://cdn.shopify.com/s/files/1/1720/3725/files/Group_1321318726_1.png?v=1767681511")';
  }

  popMainCen.style.backgroundRepeat = "no-repeat";
  popMainCen.style.backgroundPosition = "center";
  popMainCen.style.backgroundSize = "cover";

  /** ===== 🔥 复制 code 逻辑 ===== */
  const copyIcon = popMainCen.querySelector(".pic-code-icon");
  const codeTextEl = popMainCen.querySelector(".pic-code .code-text");

  if (!copyIcon || !codeTextEl) return;

  // ✅ 防止重复绑定（关键）
  if (copyIcon.dataset.bindCopy === "1") return;
  copyIcon.dataset.bindCopy = "1";

  copyIcon.addEventListener("click", function (e) {
    e.stopPropagation();

    const code = codeTextEl.textContent.trim();
    if (!code) return;

    navigator.clipboard
      .writeText(code)
      .then(() => {
        window.utils?.showCopyTip("Copied!", { type: "success" });
        closePopup();
      })
      .catch(() => {
        window.utils?.showCopyTip("Copy failed", { type: "error" });
      });
  });
}
function setSecondPicStyle(popup) {
  const popMainCen = popup.querySelector(".pop_main_cen");
  if (!popMainCen) return;

  /** ===== 样式逻辑（保持你原有的） ===== */
  if (isPC()) {
    popMainCen.style.height = "557px";
    popMainCen.style.backgroundImage =
      'url("https://cdn.shopify.com/s/files/1/1720/3725/files/Group_1321318725.png?v=1767497806")';
  } else {
    popMainCen.style.height = "428px";
    popMainCen.style.backgroundImage =
      'url("https://cdn.shopify.com/s/files/1/1720/3725/files/Group_1321318726_1.png?v=1767681511")';
  }

  popMainCen.style.backgroundRepeat = "no-repeat";
  popMainCen.style.backgroundPosition = "center";
  popMainCen.style.backgroundSize = "cover";

  /** ===== 🔥 复制 code 逻辑 ===== */
  const copyIcon = popMainCen.querySelector(".pic-code-icon");
  const codeTextEl = popMainCen.querySelector(".pic-code .code-text");

  if (!copyIcon || !codeTextEl) return;

  // ✅ 防止重复绑定（关键）
  if (copyIcon.dataset.bindCopy === "1") return;
  copyIcon.dataset.bindCopy = "1";

  copyIcon.addEventListener("click", function (e) {
    e.stopPropagation();

    const code = codeTextEl.textContent.trim();
    if (!code) return;

    navigator.clipboard
      .writeText(code)
      .then(() => {
        window.utils?.showCopyTip("Copied!", { type: "success" });
        // closePopup();
      })
      .catch(() => {
        window.utils?.showCopyTip("Copy failed", { type: "error" });
      });
    pushAnnualRewardViewEvent("popUp_Click", "popUp::AnnualReward-Win::Copy");
  });
}

/** ===============================
 * 1️⃣ 初始化配置
 =============================== */
(function initYearEndPopupConfig() {
  const isLogin = isYearEndLoggedInCustomer();
  console.log("判断是否登录01", isLogin);

  // 未登录：购物车年终横幅直接收起（PC/M 一致）
  if (!isLogin) {
    hideCartDiscountBannerCompletely();
  }

  $.ajax({
    url: `${window.API_BASE}/api/klaiyi/popup_manage`,
    method: "GET",
    headers: { Authorization: "Bearer 6JXquydq6hZG4aJyN8A5" },
    success(res) {
      // 接口 data 可能是数组（多条弹窗配置），需按 type 查找
      const list = Array.isArray(res?.data)
        ? res.data
        : res?.data
          ? [res.data]
          : [];
      const config =
        list.find((item) => item?.type === "year_end_2025") || null;
      if (!config) {
        clearCartDiscountBannerExpect();
        return;
      }

      window.__YEAR_END_POPUP_CONFIG__ = config;
      yearEndConfigReadyResolve?.();

      window.__YEAR_END_SHOW_PAGE_URL__ = config.show_page_url || [];
      window.__YEAR_END_FLOAT_NO_POPUP__ = config.content?.float_no_popup || [];

      const isLogin = isYearEndLoggedInCustomer();
      const guestValid = isGuestClickValid();
      const hasInteracted =
        localStorage.getItem("__YEAR_END_HAS_INTERACTED__") === "1";

      /** =========================
       * ⭐ 新增：刷新后 Banner 状态恢复
       ========================= */
      if (hasInteracted && guestValid) {
        // 延迟一帧，确保 DOM 已渲染
        console.log("进入未点击");
        requestAnimationFrame(() => {
          const banner = document.querySelector(".year-end-banner");
          if (!banner) return;

          const step1 = banner.querySelector(".step-1");
          const step2 = banner.querySelector(".step-2");

          if (step1 && step2) {
            step1.classList.remove("is-active");
            step2.classList.add("is-active");
          }
        });
      }

      // ===== 登录用户 =====
      if (isLogin) {
        if (!hasInteracted) {
          hideFloatingButton();
          return;
        }

        console.log("点击过领取按钮");

        shouldShowFloatingButton().then((canShow) => {
          if (!canShow) {
            hideFloatingButton();
            return;
          }
          showFloatingButton();
          updateFloatingButtonText();
        });

        return;
      }

      // ===== 未登录用户：可显示悬浮领券入口，但购物车横幅永不展示 =====
      if (guestValid) {
        console.log("进入未登录");
        hideCartDiscountBannerCompletely();
        showFloatingButton();
        updateFloatingButtonText();
      } else {
        hideFloatingButton();
      }
    },
  });
})();

let yearEndCheckPromise = null;

function fetchYearEndCouponStatus() {
  if (yearEndCheckPromise) return yearEndCheckPromise;

  const customerId = window.getAuthorization?.();
  if (!customerId) {
    yearEndCheckPromise = Promise.resolve(null);
    return yearEndCheckPromise;
  }

  yearEndCheckPromise = fetch(
    `${window.API_BASE}/api/klaiyi/popup_manage/year_end/customer_orders?customer_id=${customerId}`,
    {
      headers: {
        Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
      },
    }
  )
    .then(parseResponseJson)
    .then((res) => {
      // ⭐ 缓存接口结果
      window.__YEAR_END_CAN_SHOW__ = !!res?.data?.is_show;
      return res?.data || null;
    })
    .catch(function () {
      yearEndCheckPromise = null;
      return null;
    });

  return yearEndCheckPromise;
}
/** ===============================
 * 2️⃣ 判断是否可弹
 =============================== */
(async function checkAndShowPopup() {
  const isLogin = window.getAuthorization?.();
  console.log("判断是否登录02", isLogin);
  if (!isLogin) return;

  try {
    /** =========================
     * ① 年终活动整体开关
     ========================= */
    const data = await fetchYearEndCouponStatus();
    if (!data?.is_show) return;

    /** =========================
     * ② ⭐ 复用你已有的接口判断
     *    （内部就是 /customer_orders_coupon）
     ========================= */
    const canShow = await shouldShowFloatingButton();
    if (!canShow) {
      console.log("[YearEnd] shouldShowFloatingButton = false");
      return;
    }

    /** =========================
     * ③ 自动弹窗（只控制自动）
     ========================= */
    if (!hasReceived() && !hasClosedToday()) {
      showPopup("first");
    }

    /** =========================
     * ④ 悬浮按钮
     ========================= */
    const hasInteracted =
      localStorage.getItem("__YEAR_END_HAS_INTERACTED__") === "1";

    if (hasInteracted) {
      showFloatingButton();
      updateFloatingButtonText();
    }
  } catch (e) {
    console.error("[YearEnd] checkAndShowPopup failed", e);
  }
})();

/** ===============================
 * 3️⃣ 弹窗控制
 =============================== */
/** 弹窗展示前尽量等粗体字就绪，避免首帧假粗体闪一下 */
function ensurePopupFontsReady() {
  if (!document.fonts?.ready) return Promise.resolve();
  const rawFamily = getComputedStyle(document.body).fontFamily || "";
  const primary =
    rawFamily.split(",")[0]?.trim().replace(/^["']|["']$/g, "") || "";
  const loads =
    primary && document.fonts.load
      ? Promise.all([
          document.fonts.load(`700 24px "${primary}"`),
          document.fonts.load(`700 48px "${primary}"`),
        ]).catch(() => {})
      : Promise.resolve();
  return Promise.race([
    Promise.all([document.fonts.ready, loads]),
    new Promise((r) => setTimeout(r, 400)),
  ]);
}

function showPopup(type) {
  return ensurePopupFontsReady().then(
    () =>
      new Promise((resolve) => {
        const popup = document.querySelector(".annual-feedback");
        if (!popup) {
          resolve();
          return;
        }

        const blockList = window.__YEAR_END_SHOW_PAGE_URL__ || [];
        if (blockList.some((p) => location.pathname.startsWith(p))) {
          resolve();
          return;
        }

        const firstPic = popup.querySelector(".first-pic");
        const secondPic = popup.querySelector(".second-pic");

        popup.classList.remove("opcity-hide");
        popup.classList.add("opcity-show");
        PageOverlay?.classList.add("is-visible");

        if (type === "first") {
          firstPic?.classList.remove("opcity-hide");
          secondPic?.classList.add("opcity-hide");

          // ✅ GTM 弹窗曝光
          pushAnnualRewardViewEvent("popUp", "popUp::AnnualReward::View");

          // ⭐ 等 DOM 生效后再 resolve
          requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
          });
        }

        if (type === "second") {
          firstPic?.classList.add("opcity-hide");
          secondPic?.classList.remove("opcity-hide");

          // ✅ GTM 弹窗曝光
          pushAnnualRewardViewEvent("popUp", "popUp::AnnualReward-Win::View");

          // 原有逻辑
          setSecondPicStyle(popup);
          fillCouponCode();

          // ⭐ 等 second-pic 完全渲染完成
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              resolve();
            });
          });
        }
      })
  );
}

function closePopup() {
  const popup = document.querySelector(".annual-feedback");
  popup?.classList.add("opcity-hide");
  popup?.classList.remove("opcity-show");
  PageOverlay?.classList.remove("is-visible");
  markClosedToday();
  console.log("进入关闭弹窗函数", shouldShowFloatingButton());
  // ✅ 关闭但未领取 → 显示悬浮按钮
  if (shouldShowFloatingButton()) {
    showFloatingButton();
  }
}

/** ===============================
 * 4️⃣ 填充优惠码
 =============================== */
function fillCouponCode() {
  const config = window.__YEAR_END_POPUP_CONFIG__;
  console.log("年度回馈弹窗01:config", config);
  const title = config?.content?.packges?.[0]?.title;
  console.log("年度回馈弹窗02", title);
  const el = document.querySelector(".second-pic-cen-word-bottom");
  if (el && title) el.textContent = title;
}

/** ===============================
 * 5️⃣ 全局点击事件
 =============================== */
document.addEventListener("click", function (e) {
  const receiveBtn = e.target.closest(".js-receive-coupon");
  const firstNextBtn = e.target.closest(".first-pic-btn");
  const closeBtn = e.target.closest(".popup-close");
  const floatingCloseBtn = e.target.closest(".year-end-floating-button-colse");
  const floatingBtn = e.target.closest(".year-end-floating-button");
  const banner_receive_btn = e.target.closest(".cta-btn");

  const step1 = e.target.closest(".year-end-banner .step-1");

  /** ① 点击第一张 → 切换到第二张 ,并且算是已经领取了优惠码*/
  if (step1) {
    console.log("点击第一张banner图");
    const banner = step1.closest(".year-end-banner");
    if (!banner) return;

    banner.querySelector(".step-1")?.classList.remove("is-active");
    banner.querySelector(".step-2")?.classList.add("is-active");

    // 🔥 保留原有 select_promotion 点击事件
    window.pushBannerEvent(banner, "select_promotion", "click_step1");

    // const banner_code_pic = banner_receive_btn.closest(".year-end-step");
    const banner_couponCode =
      banner
        .querySelector(".step-2")
        ?.querySelector(".code-text")
        ?.textContent.trim() || "";

    const customerId = window.getAuthorization?.(); // 真实判断
    localStorage.setItem("__YEAR_END_HAS_INTERACTED__", "1");
    localStorage.setItem("year_end_banner-step-1", "1");
    /** =====================
     * 已登录用户
     ===================== */
    if (customerId) {
      // localStorage.setItem("__YEAR_END_FIRST_PIC_CLICKED__", "1");
      const getTime = new Date().toISOString();
      if (banner_couponCode) {
        fetch(
          `${window.API_BASE}/api/klaiyi/popup_manage/year_end/syncGet
          ?coupon_code=${banner_couponCode}
          &get_time=${encodeURIComponent(getTime)}
          &customer_id=${customerId}`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
            },
          }
        )
          .then(parseResponseJson)
          .then((data) => {
            console.log("领取优惠码接口返回：", data);
          })
          .catch((err) => {
            console.warn("领取优惠码接口报错：", err && err.message);
          });
      }

      markReceived(); // 登录态标记
    } else {
      /** =====================
     * 未登录用户
     ===================== */
      markGuestClicked(); // 只存时间
    }

    closePopup();
    showFloatingButton();

    return; // ⛔ 防止继续往下执行
  }
  // 点击banner组件领取按钮
  if (banner_receive_btn) {
    // GTM
    const routeName = window.utils?.getRouteName?.() || "otherPage";
    gtag("event", "activity_icon", {
      send_to: "G-F0NKM0YQCD",
      event_action: "click",
      event_category: routeName,
      event_label: `${routeName}_Banner::UseNow`,
    });
    return;
  }

  /** 1️⃣ second-pic：领取按钮 */
  // 点击弹窗里面的领取按钮
  if (receiveBtn) {
    closePopup();
    // GTM 埋点
    pushAnnualRewardViewEvent("popUp_Click", "popUp::AnnualReward::use now");

    return;
  }

  /** 2️⃣ first-pic：下一步按钮 */
  if (firstNextBtn && !receiveBtn) {
    console.log("点击第一个弹窗按钮");
    // ⭐⭐⭐ 关键新增：记录“已点击 first-pic-btn” ⭐⭐⭐
    localStorage.setItem("__YEAR_END_FIRST_PIC_CLICKED__", "1");
    localStorage.setItem("__YEAR_END_HAS_INTERACTED__", "1");
    pushAnnualRewardViewEvent(
      "popUp_Click",
      "popUp::AnnualReward::claim my superise"
    );
    showPopup("second").then(() => {
      // 获取 coupon_code
      // const banner = receiveBtn.closest(".year-end-banner");
      const code_pic = document.querySelector(".second-pic");
      const couponCode =
        code_pic?.querySelector(".code-text")?.textContent.trim() || "";
      const customerId = window.getAuthorization?.(); // 或者 window.__SHOPIFY_CUSTOMER_ID__ 等
      console.log("点击领取优惠码按钮", couponCode);
      // 获取当前时间
      const getTime = new Date().toISOString(); // 例如：2026-01-08T13:55:00.000Z

      // 调用接口
      if (couponCode) {
        fetch(
          `${
            window.API_BASE
          }/api/klaiyi/popup_manage/year_end/syncGet?coupon_code=${couponCode}&get_time=${encodeURIComponent(
            getTime
          )}&customer_id=${customerId || ""}`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer 6JXquydq6hZG4aJyN8A5",
            },
          }
        )
          .then(parseResponseJson)
          .then((data) => {
            console.log("领取优惠码接口返回：", data);
          })
          .catch((err) => {
            console.warn("领取优惠码接口报错：", err && err.message);
          });
      }

      markReceived(); // 只用于阻止未来自动弹窗
      // closePopup();
      showFloatingButton();
      return;
    });
  }

  /** 3️⃣ 关闭按钮 */
  if (closeBtn) {
    const step = getCurrentPopupStep();
    console.log("点击关闭按钮", step);

    if (step === "first") {
      pushAnnualRewardViewEvent("popUp_Click", "popUp::AnnualReward::Close");
    }

    if (step === "second") {
      pushAnnualRewardViewEvent(
        "popUp_Click",
        "popUp::AnnualReward-Win::Close"
      );
    }

    const hasInteracted =
      localStorage.getItem("__YEAR_END_HAS_INTERACTED__") === "1";

    closePopup();

    /**
     * ✅ 关闭后是否显示悬浮按钮
     * 规则：只要用户「已经产生过领取意图」
     */
    if (hasInteracted) {
      showFloatingButton();
    } else {
      hideFloatingButton();
    }

    return;
  }

  /** ❌ 0️⃣ 关闭悬浮按钮（session 级） */
  if (floatingCloseBtn) {
    const floating = document.querySelector(".year-end-floating-button");
    if (floating) {
      floating.classList.add("opcity-hide");
    }

    // ✅ 记录本次会话已关闭
    sessionStorage.setItem(FLOATING_SESSION_CLOSE_KEY, "1");

    // ✅ GTM - Floating Close
    pushAnnualRewardFloatingEvent("click", "btn::AnnualReward_close");
    return;
  }
  /** 4️⃣ 悬浮按钮点击 */
  if (floatingBtn) {
    console.log("点击悬浮按钮");
    const deny = window.__YEAR_END_FLOAT_NO_POPUP__ || [];
    if (deny.some((p) => location.pathname.startsWith(p))) return;

    showPopup("second");
    pushAnnualRewardFloatingEvent("click", "btn::AnnualReward");
  }
});
function getCurrentPopupStep() {
  console.log("判断点击的是哪里的按钮");
  const popup = document.querySelector(".annual-feedback");
  if (!popup) return "unknown";

  const firstPic = popup.querySelector(".first-pic");
  const secondPic = popup.querySelector(".second-pic");

  if (firstPic && !firstPic.classList.contains("opcity-hide")) {
    return "first";
  }

  if (secondPic && !secondPic.classList.contains("opcity-hide")) {
    return "second";
  }

  return "unknown";
}

// 个人中心优惠码
function insertCouponToMyCoupon({ title, code, price }) {
  const couponContainer = document.querySelector(".c-c-m-c-coupon");
  if (!couponContainer) return;

  // 如果已经插入过，直接 return（防止重复）
  if (couponContainer.querySelector(".coupon-item.year-end-coupon")) return;

  const firstCoupon = couponContainer.querySelector(".coupon-item");

  // 解析 title，例如 "26% OFF"
  const discountValue = title.replace(/[^0-9]/g, ""); // 26
  const minSpend = price; // 如果接口有可用字段可以替换

  const couponItem = document.createElement("div");
  couponItem.className = "coupon-item pos-relative-item year-end-coupon";

  couponItem.innerHTML = `
    <div class="pos-relative-parent">
      <div class="pos-relative-son">
        <div class="left-round"></div>
        <div class="right-round"></div>
      </div>
    </div>

    <div class="coupon-header">
      <p class="p1">
        <span>${title}</span>
      </p>
      <p class="p2">
        <span>${minSpend}</span>
      </p>
    </div>

    <div class="coupon-body">
      <div class="coupon-code">
        Code: <span class="code-text">${code}</span>
      </div>
      <button class="copy-btn">Copy Code</button>
    </div>

    <i class="c-c-m-c-coupon-k">    
      <svg xmlns="http://www.w3.org/2000/svg" width="108" height="110" viewBox="0 0 108 110" fill="none">
        <path d="M66.8934 89.88C65.497 79.5002 61.0377 49.0418 45.8537 48.2182C45.8537 48.2182 71.8648 47.4406 80.2387 69.148C88.6127 90.8554 93.086 98.4378 97.0845 98.7737C101.083 99.1095 104.425 96.8505 106.985 90.722C107.032 90.6124 107.108 90.5172 107.204 90.4461C107.301 90.375 107.415 90.3304 107.535 90.3171C108 90.3171 108 90.699 108 90.699C108 90.699 102.926 107.193 89.1434 108.919C88.1677 109.042 87.1852 109.105 86.2015 109.107C74.3271 109.112 68.1782 99.4914 66.8934 89.88ZM51.2067 107.051H37.4099V94.3061C38.6388 105.588 51.0345 106.549 51.2067 106.563C51.267 106.565 51.3242 106.59 51.3672 106.631C51.4103 106.673 51.4361 106.729 51.4395 106.789C51.4458 106.822 51.4445 106.856 51.4356 106.889C51.4267 106.921 51.4104 106.952 51.3881 106.977C51.3657 107.003 51.3378 107.023 51.3064 107.037C51.275 107.05 51.241 107.052 51.2067 107.051ZM0.00391047 106.789C0.00741955 106.73 0.0333418 106.674 0.076493 106.633C0.119644 106.592 0.176843 106.569 0.236651 106.568V107.055C0.202436 107.057 0.168371 107.05 0.136983 107.037C0.105594 107.023 0.0776869 107.003 0.0553312 106.977C0.0329756 106.952 0.016745 106.921 0.00784343 106.889C-0.00105816 106.856 -0.00240238 106.822 0.00391047 106.789ZM14.0568 107.055V1.95725e-07H50.9414C51.0163 0.00589186 51.086 0.0404343 51.1355 0.096283C51.1851 0.152132 51.2106 0.224881 51.2067 0.299063C51.2113 0.336915 51.208 0.375277 51.1973 0.411882C51.1866 0.448487 51.1685 0.482594 51.1442 0.512188C51.1199 0.541781 51.0899 0.566262 51.0558 0.584183C51.0218 0.602105 50.9845 0.613104 50.9461 0.61653C50.9461 0.61653 50.9461 0.575122 50.9461 0.510708V0.61653C50.9461 0.61653 38.5271 1.50912 37.4053 11.8705V107.051L14.0568 107.055ZM0.24596 107.055V106.568C0.24596 106.568 12.8139 105.68 14.0568 94.3061V107.055H0.24596ZM55.2564 42.6004C61.991 34.5926 67.8136 25.8765 72.6188 16.6095L72.7631 16.315C79.7593 -0.179436 66.4186 0.61653 66.4186 0.61653C66.38 0.613735 66.3423 0.603151 66.308 0.585429C66.2736 0.567707 66.2433 0.543222 66.2189 0.513482C66.1945 0.483742 66.1765 0.449377 66.166 0.412501C66.1555 0.375626 66.1528 0.337021 66.158 0.299063C66.1561 0.260457 66.1621 0.221874 66.1758 0.185655C66.1895 0.149437 66.2104 0.116339 66.2374 0.0883705C66.2644 0.0604021 66.2968 0.0381469 66.3328 0.0229559C66.3688 0.00776489 66.4075 -4.50794e-05 66.4466 1.95725e-07L80.6623 0.0276061L88.4452 0.013803H101.972C102.011 0.0137577 102.05 0.0215678 102.086 0.0367588C102.122 0.0519498 102.154 0.074205 102.181 0.102173C102.208 0.130142 102.229 0.16324 102.243 0.199458C102.256 0.235677 102.263 0.27426 102.261 0.312866C102.265 0.350718 102.262 0.38908 102.251 0.425685C102.24 0.46229 102.222 0.496397 102.198 0.525991C102.174 0.555584 102.144 0.580065 102.11 0.597986C102.076 0.615907 102.038 0.626906 102 0.630333C102 0.630333 91.9316 0.791368 76.6592 18.7904L77.3574 17.6769L76.7058 18.6753L56.6063 43.5988L55.2564 42.6004ZM0.49732 0.61653C0.459326 0.612533 0.422513 0.601117 0.389017 0.582947C0.355521 0.564776 0.326009 0.540212 0.302193 0.510679C0.278377 0.481146 0.260731 0.447233 0.250279 0.410907C0.239827 0.37458 0.236777 0.336564 0.241305 0.299063C0.238776 0.261073 0.244093 0.22297 0.256932 0.187075C0.269772 0.151179 0.289867 0.118242 0.315993 0.0902655C0.342119 0.0622894 0.373731 0.0398599 0.408905 0.024342C0.444079 0.00882405 0.482079 0.000542146 0.520594 1.95725e-07H14.0521V11.8705C12.9396 1.63795 0.804537 0.639535 0.49732 0.61653Z" fill="#D0A179" fill-opacity="0.27"/>
      </svg>
    </i>
  `;

  // 复制按钮逻辑
  couponItem.querySelector(".copy-btn").addEventListener("click", () => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(() => {
        window.utils.showCopyTip("Copied!", { type: "success" });
      });
    }
  });

  // 插入到第一张
  if (firstCoupon) {
    couponContainer.insertBefore(couponItem, firstCoupon);
  } else {
    couponContainer.appendChild(couponItem);
  }
}

// gtag 埋点
// 年终回馈弹窗
// 年终回馈弹窗 gtag 埋点
function pushAnnualRewardViewEvent(btn_event, event_label_name) {
  if (typeof gtag !== "function") return;

  gtag("event", "popUp", {
    send_to: "G-F0NKM0YQCD",
    event_action: btn_event, // 如 popUp_Click
    event_category: getAnnualFeedbackRouteName(), // 当前路由
    event_label: event_label_name, // 如 popUp::AnnualReward::View
  });
}
// 年终回馈侧边栏 gtag 埋点
function pushAnnualRewardFloatingEvent(btn_event, event_label_name) {
  if (typeof gtag !== "function") return;
  gtag("event", "sideBar", {
    send_to: "G-F0NKM0YQCD",
    event_action: btn_event, // 如 floating_click
    event_category: getAnnualFeedbackRouteName(), // 当前路由
    event_label: event_label_name, // 如 floating::AnnualReward::click
  });
}
function markGuestClicked() {
  localStorage.setItem(GUEST_CLICK_TIME_KEY, Date.now().toString());
}
function isGuestClickValid() {
  const time = localStorage.getItem(GUEST_CLICK_TIME_KEY);
  if (!time) return false;
  console.log("获取未登录状态下是否在有效期", Number(time));
  const diff = Date.now() - Number(time);
  const max = GUEST_EXPIRE_DAYS * 24 * 60 * 60 * 1000;
  // const max = 3 * 60 * 1000;
  console.log("未登录状态下是否在有效期", diff, max);
  return diff <= max;
}
async function initYearEndFloatingButton() {
  console.log("未登录查看悬浮弹窗是否显示", shouldShowFloatingButton);
  try {
    shouldShowFloatingButton().then((canShow) => {
      console.log("走接口", canShow);
      if (canShow) {
        console.log("走接口1");
        showFloatingButton();
        updateFloatingButtonText();
      } else {
        console.log("不走接口");
        hideFloatingButton();
      }
    });
  } catch (e) {
    console.error("[YearEnd] init floating failed", e);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const isLogin = window.getAuthorization?.();
  if (!isLogin) {
    initYearEndFloatingButton();
  }
});
